// Module
var code = "<div class=\"doubleScroll_wrapper\"> <div class=\"doubleScroll_Wrapper_1\"> <div class=\"doubleScroll_Wrapper_1_DivScroll\"> </div> </div> <div class=\"table-view-config clearfix doubleScroll_Wrapper_2\"> <!-- ko with: _groups --> <!-- ko template: { html: $data.GetTemplate.bind($data) } --><!-- /ko --> <!-- /ko --> </div> </div>";
// Exports
export default code;